import createCardListingView from '../Views/createCardListingView';
import FlexCompetitionCard from './FlexCompetitionCard';

export default createCardListingView(FlexCompetitionCard, {
  displayName: 'CompetitionListingView',
});
